import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { RootState } from '@/app/store'
import * as AWS from 'aws-sdk/global'
import {
  CognitoUserPool,
  CognitoRefreshToken,
} from 'amazon-cognito-identity-js'
import awsConfiguration from '@/lib/awsconfiguration'
import { urlquestionnairesanswer } from '@/lib/custom'
import { originalUseSWR } from '@/lib/originalUseSWR'
import { removeLocalStorage } from '@/lib/removeLocalstorage'
import { rutequery } from './rutequery'

const PageView = () => {
  AWS.config.region = awsConfiguration.region
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: awsConfiguration.IdentityPoolId,
  })

  const [AnsweredState, setAnsweredState] = useState('')
  const userPool = new CognitoUserPool({
    UserPoolId: awsConfiguration.UserPoolId,
    ClientId: awsConfiguration.ClientId,
  })

  const router = useRouter()

  const loginTypeStateSelector = useSelector(
    (loginTypeState: RootState) => loginTypeState.loginType.loginType
  )

  console.log(loginTypeStateSelector)

  const refreshFunc = () => {
    const cognitoUser = userPool.getCurrentUser()
    // alert(
    //   visibility +
    //     'timestamp : ' +
    //     format(new Date(), 'mm:ss') +
    //     ' : usePageHooks 30 / cognitoUser : ' +
    //     JSON.stringify(cognitoUser)
    // )

    if (cognitoUser != null) {
      cognitoUser.getSession((err: any, session: any) => {
        // @ts-ignore
        // const refresh_token = JSON.parse(
        //   localStorage.getItem(
        //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh-jwt`
        //   )
        // )

        // const refreshToken = new CognitoRefreshToken({
        //   RefreshToken: refresh_token,
        // })

        // alert(
        //   'timestamp : ' +
        //     format(new Date(), 'mm:ss') +
        //     ' : usePageHooks 54 / refresh token : ' +
        //     JSON.stringify(refreshToken) +
        //     ' :  md5変換 / ' +
        //     md5(session.getAccessToken().getJwtToken())
        // )
        const refresh_token = session.getRefreshToken()

        const exp =
          // @ts-ignore
          localStorage.getItem(
            `${process.env.NEXT_PUBLIC_SERVICE_NAME}-exp-token`
          ) * 1000
        const now = new Date().getTime()

        if (now > exp) {
          cognitoUser.refreshSession(refresh_token, (err, session) => {
            // if (session.isValid()) {
            // alert(
            //   visibility +
            //     ' : ' +
            //     'timestamp : ' +
            //     format(new Date(), 'mm:ss') +
            //     ' : usePageHooks / 更新！！JWT Token Name : ' +
            //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
            // )

            // alert(
            //   visibility +
            //     'timestamp : ' +
            //     format(new Date(), 'mm:ss') +
            //     ' : usePageHooks / 更新！！access token : ' +
            //     JSON.stringify(session.getAccessToken().getJwtToken()) +
            //     ' :  md5変換 / ' +
            //     md5(session.getAccessToken().getJwtToken())
            // )

            // alert('originalUseSWR 95 / デコードJWT : ' + JSON.stringify(decode))

            localStorage.setItem(
              `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
              session.getAccessToken().getJwtToken()
            )

            localStorage.setItem(
              `${process.env.NEXT_PUBLIC_SERVICE_NAME}-exp-token`,
              session.accessToken.payload.exp
            )

            // }
          })
        }
      })
      return
    }

    removeLocalStorage()
  }

  const Questionnaires = async () => {
    try {
      const authAuestionnairesFetch = await originalUseSWR(
        `${urlquestionnairesanswer}/1`
      )
      const result = (await authAuestionnairesFetch) as any

      console.log(result)

      const userPool = new CognitoUserPool({
        UserPoolId: awsConfiguration.UserPoolId,
        ClientId: awsConfiguration.ClientId,
      })

      const cognitoUser = userPool.getCurrentUser()

      if (result.status === 404) {
        setAnsweredState('answered')
        localStorage.setItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
          'answered'
        )
        return
      }

      if (result.code === 'answered') {
        console.log('pageHooks answered')

        setAnsweredState('answered')
        localStorage.setItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
          'answered'
        )
      }

      if (result.code === 'unanswered') {
        console.log('unanswered')
        setAnsweredState('unanswered')
        localStorage.setItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`,
          'unanswered'
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const checkQuest = () => {
    const flag = localStorage.getItem(
      `${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`
    )

    if (flag) {
      if (flag === 'unanswered') {
        // location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
      }
    } else {
      Questionnaires()
    }
  }

  useEffect(() => {
    const tranformQuery = rutequery(router)
    const Period = localStorage.getItem(
      `${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`
    )

    const JWT = localStorage.getItem(
      `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
    )

    if (
      router.pathname == '/auth/signin' ||
      router.pathname == '/auth/register'
    ) {
      return
    } else {
      if (JWT === null) {
        if (!Period) {
          if (tranformQuery.hash) {
            location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/qrerror`
            return
          }

          if (router.pathname == '/qrerror') return
          // if(loginTypeStateSelector !== 9){
          location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
          // }
        }

        // return
      } else {
        refreshFunc()
        checkQuest()
      }
    }
  }, [])

  useEffect(() => {
    const handleRouteChange = () => {
      const JWT = localStorage.getItem(
        `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
      )

      if (
        router.pathname == '/auth/signin' ||
        router.pathname == '/auth/register'
      ) {
        return
      } else {
        if (JWT === null) {
          return
        } else {
          checkQuest()
          refreshFunc()
        }
      }
    }

    router.events.on('routeChangeComplete', handleRouteChange)
    router.events.on('routeChangeStart', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.events, AnsweredState])

  return <></>
}

export default PageView
